// extracted by mini-css-extract-plugin
export default {"root":"ToolTip_root__IogHj","text":"ToolTip_text__lqqjl"};